import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import { LicenseInsightPayload } from './Decoder';
import LicenseCard from './LicenseCard';
import ProductLicense from './ProductLicense';
import OverallocationLicenseAlert from './OverallocationLicenseAlert';

interface Props {
  index: number;
  licenseInsight: LicenseInsightPayload;
}

function LicenseAlert({ index, licenseInsight }: Props) {
  switch (licenseInsight.kind) {
    case 'overallocation-alert':
      return <OverallocationLicenseAlert insightIndex={index} licenseInsight={licenseInsight} />;
    case 'expiration-alert':
      return (
        <LicenseCard>
          <Typography color="amber" variant="bodyMedium" fontWeight="medium" className="mb-2">
            <T kind="A license is expiring in less than 90 days" />
          </Typography>
          <ProductLicense insightIndex={index} productLicenses={licenseInsight.productLicenses} />
        </LicenseCard>
      );
    case 'invite-more-participants-alert':
      return (
        <LicenseCard>
          <Typography variant="bodyMedium" fontWeight="medium" color="dark" className="mb-2">
            <T kind="Invite more participants to collections" />
          </Typography>
          <ProductLicense insightIndex={index} productLicenses={licenseInsight.productLicenses} />
        </LicenseCard>
      );
  }
}

export default observer(LicenseAlert);
